export const SI = (
    <div>
        <p className="title"><b>Summer Institute</b></p>
        <div>

            <b className="programs-span">2024 SDNI Nanotechnology Summer Institute for Middle and High School Teachers</b><br /><br />
            <p>Participant in the SDNI Nanotechnology Summer Institute for Middle and High School Teachers will learn how nanotechnology content can integrate
                with their current California K-12 NGSS science curricula. During the program, teachers will acquire knowledge that will enable them to prepare a
                lesson plan that integrates nanotechnology with their science programs and implement such lesson plan during the school year 2024-2025. The instructor
                will be available to assist in the creation and implementation of the lesson plans not only during the training, but during the entire school year
                2024-2025 and beyond.<br /><br />
                In order to qualify, applicants must be Science or Math teachers and ready to attend the 5-day program every day of the program (mandatory). Teachers must also implement their
                lessons during the school year 2024-2025.
                <br /><br />
                No travel or lodging expenses are covered for this program.</p>

            <b className="programs-span">Professional Development Credits:</b>
            <p>Participants in this program will received 30 hours of Professional Development Units that can be reported to their school districts.</p>
            
            <b className="programs-span">Provided Stipend/Materials: </b>
            <li>$500 at completion of the 5-day program</li>
            <li>$300 after in-class implementation of the lesson plan</li>
            <li>Materials for hands-on activities (up to $400 value)</li>

            <br />
            <p>The training will be online for the first 4 days and in-person on Day 5.

                We will prepare materials kits that teachers will use from home or from their classroom.

                All hands-on activities will be facilitated by live monitoring from Instructor.</p>
            <b className="programs-span">Application Period:</b> Open – ends May 31, 2024. Qualified candidates will be selected on a first arrive first enrolled basis.
            <br /><br />
            <b className="programs-span">To apply, please email Yves Theriault at <a href={"mailto:ytheriault@ucsd.edu"}>ytheriault@ucsd.edu</a> and provide the following information:
                <li>Full name</li>
                <li>Name of School where teaching</li>
                <li>Grade level(s)</li>
                <li>Science or Math Topic(s) taught</li>
                <li>Please also indicate your choice of one the following week for the 5-day training: June 24-28 or July 15-19</li>
                </b>
            <br />
            <br />

        </div>
    </div>
)
